import { Translations } from './types';

export const fr: Translations = {
  // Navigation
  nav: {
    features: 'Fonctionnalités',
    about: 'À propos',
    pricing: 'Tarifs',
    support: 'Support',
    admin: 'Admin',
    downloadApp: 'Télécharger l\'App',
  },

  // Hero Section
  hero: {
    title: 'Une app d\'inspiration que vous *adorerez*',
    subtitle: 'Inspiration quotidienne, images générées par IA et réflexions personnelles pour une vie plus motivée',
    downloadIOS: 'Télécharger pour iOS',
    downloadIOSTestFlight: 'Télécharger pour iOS (TestFlight)',
    comingSoonAndroid: 'Bientôt sur Android',
    freeTrialNote: 'Aucune carte de crédit requise • 7 jours d\'essai gratuit',
    note: 'Aucune carte de crédit requise • 3 jours d\'essai gratuit',
    mockupQuote: 'La meilleure façon de prédire l\'avenir est de le créer.',
    mockupAuthor: '- Peter Drucker',
    playVideo: 'Lire la vidéo',
  },

  // Quote Example
  quote: {
    example: 'La meilleure façon de prédire l\'avenir est de le créer.',
    author: 'Peter Drucker',
    category: 'Leadership et État d\'esprit',
  },

  // Features Section
  features: {
    title: 'Tout ce dont vous avez besoin pour l\'inspiration quotidienne',
    subtitle: 'Découvrez le parcours complet de l\'inspiration quotidienne',
    screenshots: {
      categories: {
        title: 'Personnalisez votre parcours',
        description: 'Choisissez parmi 5 catégories qui correspondent à vos objectifs : Inspiration Quotidienne, Sports, Leadership, Pleine Conscience et Relations.',
      },
      favorites: {
        title: 'Collectionnez vos favoris',
        description: 'Sauvegardez les citations qui vous inspirent le plus et revisitez-les quand vous avez besoin de motivation.',
      },
      share: {
        title: 'Partagez votre inspiration',
        description: 'Répandez l\'énergie positive en partageant de magnifiques cartes de citations avec vos amis et votre famille.',
      },
    },
    feature1: {
      title: 'Inspiration Quotidienne',
      description: 'Une nouvelle citation motivante chaque jour parmi 5 catégories : Inspiration, Sport, Leadership, Pleine Conscience et Relations.',
    },
    feature2: {
      title: 'Images Générées par IA',
      description: 'Chaque citation est présentée avec une image de fond unique générée par IA qui correspond parfaitement à l\'ambiance.',
    },
    feature3: {
      title: 'Réflexion Personnelle',
      description: 'Notez vos pensées sur chaque citation et suivez votre développement personnel au fil du temps.',
    },
    feature4: {
      title: 'Rappels Intelligents',
      description: 'Recevez votre inspiration quotidienne au moment parfait - personnalisable et discret.',
    },
    feature5: {
      title: 'Multilingue',
      description: 'Disponible en allemand, anglais, espagnol et français - tout s\'adapte automatiquement à votre langue.',
    },
    feature6: {
      title: 'Fonctionne hors ligne',
      description: 'Votre inspiration est toujours disponible, même sans connexion internet.',
    },
    dailyInspiration: {
      title: 'Inspiration Quotidienne',
      description: 'Une nouvelle citation motivante chaque jour dans 5 catégories.',
    },
    aiImages: {
      title: 'Images Générées par IA',
      description: 'Chaque citation est présentée avec une image unique générée par IA.',
    },
    personalReflection: {
      title: 'Réflexion Personnelle',
      description: 'Écrivez vos pensées sur chaque citation.',
    },
    smartReminders: {
      title: 'Rappels Intelligents',
      description: 'Recevez votre inspiration au moment parfait.',
    },
    multilingual: {
      title: 'Multilingue',
      description: 'Disponible en allemand, anglais, espagnol et français.',
    },
    offline: {
      title: 'Fonctionne hors ligne',
      description: 'Votre inspiration est toujours disponible.',
    },
  },

  // Categories Section
  categories: {
    title: '5 catégories pour chaque domaine de la vie',
    daily: {
      name: 'Inspiration Quotidienne',
      description: 'Citations motivantes pour chaque jour',
    },
    sport: {
      name: 'Sport et Discipline',
      description: 'Motivation pour l\'entraînement et la persévérance',
    },
    leadership: {
      name: 'Leadership et État d\'esprit',
      description: 'Leadership et pensée entrepreneuriale',
    },
    mindfulness: {
      name: 'Pleine Conscience et Équilibre',
      description: 'Paix intérieure et équilibre de vie',
    },
    relationships: {
      name: 'Relations et Proximité',
      description: 'Amour, amitié et connexions interpersonnelles',
    },
    inspiration: {
      title: 'Inspiration Quotidienne',
      description: 'Citations motivantes pour votre quotidien',
    },
    sports: {
      title: 'Sport et Discipline',
      description: 'Renforcez votre corps et votre esprit',
    },
  },

  // Pricing Section
  pricing: {
    title: 'Choisissez votre Plan',
    subtitle: 'Débloquez toutes les fonctionnalités premium',
    monthly: {
      title: 'Mensuel',
      price: '€2,99',
      period: 'par mois',
      features: [
        'Inspiration quotidienne',
        'Images générées par IA',
        'Journal personnel',
        'Rappels personnalisables',
        'Toutes les catégories',
        'Fonctions d\'exportation',
        'Sans publicité',
      ],
      cta: 'Choisir Mensuel',
    },
    yearly: {
      title: 'Annuel',
      price: '€14,99',
      period: 'par an',
      badge: 'Meilleure Valeur',
      features: [
        'Inspiration quotidienne',
        'Images générées par IA',
        'Journal personnel',
        'Rappels personnalisables',
        'Toutes les catégories',
        'Fonctions d\'exportation',
        'Sans publicité',
      ],
      cta: 'Choisir Annuel',
      savings: 'Économisez 58%',
    },
  },

  // Footer
  footer: {
    copyright: 'Tous droits réservés.',
    madeWith: 'Fait avec ❤️ en Allemagne',
    product: {
      title: 'Produit',
      features: 'Fonctionnalités',
      pricing: 'Tarifs',
      admin: 'Admin',
    },
    support: {
      title: 'Support',
      help: 'Aide',
      contact: 'Contact',
      faq: 'FAQ',
    },
    legal: {
      title: 'Légal',
      privacy: 'Confidentialité',
      terms: 'Conditions d\'utilisation',
      imprint: 'Mentions légales',
      eula: 'Accord de Licence Utilisateur Final',
    },
  },
};